(()=>{
  function init(root){
    if(root.dataset.initialized)return;
    root.dataset.initialized='true';
    const gallery=root.querySelector('.ov-gallery');
    const slideTrack=gallery?.querySelector('[data-gallery-slides]');
    const slides=[...(slideTrack?.querySelectorAll('[data-gallery-slide]')||[])];
    const thumbnailStrip=gallery?.querySelector('.ov-thumbnails');
    const thumbnails=[...(gallery?.querySelectorAll('[data-gallery-src]')||[])];
    const reduceMotion=window.matchMedia?.('(prefers-reduced-motion: reduce)');
    let galleryIndex=Math.max(0,thumbnails.findIndex(button=>button.classList.contains('is-active')));
    const selectGalleryImage=(index)=>{
      if(!slideTrack||!slides.length||!thumbnails.length)return;
      // Keep the full image strip mounted so the slide visibly crosses every intervening photo.
      galleryIndex=Math.max(0,Math.min(index,Math.min(slides.length,thumbnails.length)-1));
      const activeThumb=thumbnails[galleryIndex];
      const frame=gallery.querySelector('.ov-main-photo');
      const aspectRatio=Number(slides[galleryIndex].dataset.galleryAspectRatio);
      if(frame&&Number.isFinite(aspectRatio)&&aspectRatio>0)frame.style.aspectRatio=String(aspectRatio);
      // Start loading images along the requested slide path immediately.
      slides.forEach((slide,i)=>{
        if(Math.abs(i-galleryIndex)<=2){
          const img=slide.querySelector('img');
          if(img)img.loading='eager';
        }
        slide.setAttribute('aria-hidden',String(i!==galleryIndex));
      });
      slideTrack.style.transform='translate3d(-'+(galleryIndex*100)+'%,0,0)';
      thumbnails.forEach((thumb,i)=>{
        const selected=i===galleryIndex;
        thumb.classList.toggle('is-active',selected);
        thumb.setAttribute('aria-pressed',String(selected));
      });
      gallery.querySelectorAll('[data-gallery-previous]').forEach(button=>{
        button.disabled=galleryIndex===0;
      });
      gallery.querySelectorAll('[data-gallery-next]').forEach(button=>{
        button.disabled=galleryIndex===thumbnails.length-1;
      });
      if(thumbnailStrip&&thumbnails.length>1){
        const targetLeft=activeThumb.offsetLeft-(thumbnailStrip.clientWidth-activeThumb.offsetWidth)/2;
        thumbnailStrip.scrollTo({left:targetLeft,behavior:reduceMotion?.matches?'auto':'smooth'});
      }
    };
    thumbnails.forEach((thumb,i)=>thumb.addEventListener('click',()=>selectGalleryImage(i)));
    gallery?.querySelectorAll('[data-gallery-previous]').forEach(button=>button.addEventListener('click',()=>selectGalleryImage(galleryIndex-1)));
    gallery?.querySelectorAll('[data-gallery-next]').forEach(button=>button.addEventListener('click',()=>selectGalleryImage(galleryIndex+1)));
    if(thumbnails.length>1)selectGalleryImage(galleryIndex);
    // Keep the gallery review right below the photos on mobile, but relocate its
    // *existing* video carousel below benefits and above the FAQs.
    // The element is moved, never cloned, preserving its player controls and block settings.
    const originalVideoHome=root.querySelector('.ov-gallery-social-proof');
    const mobileVideoHome=root.querySelector('[data-ov-mobile-videos-slot]');
    const videoCarousel=originalVideoHome?.querySelector('ovela-video-carousel.ov-gallery-videos');
    const mobileVideoQuery=window.matchMedia('(max-width:760px)');
    const placeProductVideos=()=>{
      if(!originalVideoHome||!mobileVideoHome||!videoCarousel)return;
      const newParent=mobileVideoQuery.matches?mobileVideoHome:originalVideoHome;
      if(videoCarousel.parentElement===newParent)return;
      videoCarousel.querySelectorAll('video').forEach(video=>{if(!video.paused)video.pause();});
      newParent.appendChild(videoCarousel);
    };
    placeProductVideos();
    if(videoCarousel){
      if(typeof mobileVideoQuery.addEventListener==='function'){
        mobileVideoQuery.addEventListener('change',placeProductVideos);
      }else if(typeof mobileVideoQuery.addListener==='function'){
        mobileVideoQuery.addListener(placeProductVideos);
      }
    }
    root.querySelectorAll('.ov-preferences input').forEach(input=>input.addEventListener('change',()=>{
      const tags=root.querySelector('[data-routine-tags]');
      if(tags)tags.value='newsletter,ovela-launch,routine-'+input.value;
    }));
    root.querySelectorAll('a[href^="#"]').forEach(link=>link.addEventListener('click',()=>{
      const menu=root.querySelector('.ov-mobile-menu');
      if(menu)menu.open=false;
      if(link.hash==='#ov-contact'){
        const contact=root.querySelector('#ov-contact');
        if(contact)contact.open=true;
      }
    }));
    const sticky=root.querySelector('[data-ov-sticky]');
    const purchaseForm=root.querySelector('.ov-product-form');
    const purchaseButton=purchaseForm?.querySelector('.ov-checkout-button');
    const stickyButton=root.querySelector('[data-ov-sticky-add]');
    const drawer=root.querySelector('[data-ov-cart-drawer]');
    let previousFocus=null;
    let closingTimer=null;
    let cartData=null;
    const cartBase=drawer?.dataset.cartBase||window.Shopify?.routes?.root||'/';
    // Locale-aware by default; fallback only if Shopify explicitly rejects the
    // Spanish-prefixed endpoint with 404/405 (avoid duplicate successful POSTs).
    const fetchCartRoute=async(path,options={})=>{
      let response=await fetch(cartBase+path,options);
      if(cartBase!=='/'&&(response.status===404||response.status===405)){
        response=await fetch('/'+path,options);
      }
      return response;
    };
    // Bind product submission in init(), not an inline section script: it survives
    // Shopify theme-editor section replacement and language switching.
    purchaseForm?.addEventListener('submit',async(event)=>{
      event.preventDefault();
      const selectedVariant=purchaseForm.querySelector('input[name="id"]:checked:not(:disabled)')||
        purchaseForm.querySelector('input[name="id"]:not(:disabled)');
      const selectedQuantity=purchaseForm.querySelector('input[name="quantity"]:checked');
      const quantity=selectedQuantity?Number(selectedQuantity.value):1;
      const variantId=selectedVariant?Number(selectedVariant.value):NaN;
      const errorPanel=purchaseForm.querySelector('[data-ov-add-error]');
      if(errorPanel)errorPanel.hidden=true;
      if(!Number.isSafeInteger(variantId)||variantId<=0||!Number.isSafeInteger(quantity)||quantity<=0){
        if(errorPanel){errorPanel.textContent=errorPanel.dataset.ovErrorLabel||'Unable to add this product.';errorPanel.hidden=false;}
        return;
      }
      if(purchaseButton?.disabled)return;
      const label=purchaseButton?.querySelector('.ov-checkout-main');
      const originalLabel=label?.textContent;
      if(purchaseButton){purchaseButton.disabled=true;purchaseButton.setAttribute('aria-busy','true');}
      if(label)label.textContent=purchaseButton?.dataset.ovAddingLabel||originalLabel||'Adding…';
      try{
        const response=await fetchCartRoute('cart/add.js',{
          method:'POST',credentials:'same-origin',
          headers:{'Content-Type':'application/json',Accept:'application/json'},
          body:JSON.stringify({items:[{id:variantId,quantity}]})
        });
        const payload=await response.json().catch(()=>null);
        if(!response.ok||!payload||!(Array.isArray(payload.items)||payload.id)){
          const errorMessage=typeof payload?.description==='string'?payload.description:
            typeof payload?.message==='string'?payload.message:'Cart add failed.';
          throw Error(errorMessage);
        }
        if(drawer)root.dispatchEvent(new CustomEvent('ovela:cart:added',{bubbles:true}));
        else window.location.assign(cartBase+'cart');
      }catch(error){
        console.error('Ovela cart add failed:',error);
        if(errorPanel){
          const friendly=errorPanel.dataset.ovErrorLabel||'Unable to add this product.';
          errorPanel.textContent=friendly+(error?.message?' ('+error.message+')':'');
          errorPanel.hidden=false;
        }
      }finally{
        if(purchaseButton){purchaseButton.disabled=false;purchaseButton.removeAttribute('aria-busy');}
        if(label&&originalLabel!=null)label.textContent=originalLabel;
      }
    });
    const cartMoney=(cents,currency)=>{
      try{return new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:currency||'USD'}).format((Number(cents)||0)/100);}
      catch(error){return ((Number(cents)||0)/100).toFixed(2);}
    };
    const drawerEl=(tag,className,value)=>{
      const el=document.createElement(tag);
      if(className)el.className=className;
      if(value!==undefined&&value!==null)el.textContent=String(value);
      return el;
    };
    const updateSticky=()=>{
      if(!sticky||!purchaseButton)return;
      const past=purchaseButton.getBoundingClientRect().bottom<0;
      const open=Boolean(drawer&&!drawer.hidden&&drawer.classList.contains('is-open'));
      sticky.classList.toggle('is-visible',past&&!open);
    };
    function renderDrawer(cart){
      if(!drawer)return;
      cartData=cart;
      const itemsContainer=drawer.querySelector('[data-ov-drawer-items]');
      const footer=drawer.querySelector('[data-ov-drawer-footer]');
      const count=drawer.querySelector('[data-ov-drawer-count]');
      const total=drawer.querySelector('[data-ov-drawer-subtotal]');
      const checkoutTotal=drawer.querySelector('[data-ov-drawer-checkout-total]');
      if(!itemsContainer||!footer)return;
      itemsContainer.replaceChildren();
      const items=Array.isArray(cart.items)?cart.items:[];
      const moneyValue=cartMoney(cart.total_price,cart.currency);
      if(count)count.textContent='· '+(cart.item_count||0);
      if(total)total.textContent=moneyValue;
      if(checkoutTotal)checkoutTotal.textContent=moneyValue;
      // Report genuine discounts, including free items, without double-counting.
      const lineSavings=items.reduce((sum,item)=>{
        const original=Number(item.original_line_price);
        const final=Number(item.final_line_price);
        return sum+(Number.isFinite(original)&&Number.isFinite(final)?Math.max(0,original-final):0);
      },0);
      const originalTotal=Number(cart.original_total_price);
      const finalTotal=Number(cart.total_price);
      const cartSavings=Number.isFinite(originalTotal)&&Number.isFinite(finalTotal)?
        Math.max(0,originalTotal-finalTotal):0;
      const savingsCents=Math.max(lineSavings,cartSavings);
      const savingsRow=drawer.querySelector('[data-ov-drawer-savings]');
      const savingsAmount=drawer.querySelector('[data-ov-drawer-savings-amount]');
      if(savingsRow)savingsRow.hidden=savingsCents<=0;
      if(savingsAmount)savingsAmount.textContent='−'+cartMoney(savingsCents,cart.currency);
      // Show bundle perks only as unlocked when a free line is actually in the cart.
      const freeUnits=items.reduce((sum,item)=>{
        const wasCharged=Number(item.original_line_price||0)>0;
        const isFree=Number(item.final_line_price)===0&&wasCharged;
        return sum+(isFree?Number(item.quantity||0):0);
      },0);
      const bundleThree=drawer.querySelector('[data-ov-bundle-three]');
      const bundleFive=drawer.querySelector('[data-ov-bundle-five]');
      bundleThree?.classList.toggle('is-unlocked',freeUnits===1);
      bundleFive?.classList.toggle('is-unlocked',freeUnits>=2);
      const bundleStatus=drawer.querySelector('[data-ov-bundle-status]');
      if(bundleStatus){
        bundleStatus.textContent=freeUnits>=2?drawer.dataset.bundleFiveStatus:
          freeUnits===1?drawer.dataset.bundleThreeStatus:
          drawer.dataset.bundleStatus;
      }
      // Shopify AJAX cart totals are in minor currency units, after discounts.
      const shipping=drawer.querySelector('[data-ov-shipping]');
      if(shipping){
        const usd=!cart.currency||cart.currency==='USD';
        shipping.hidden=!usd;
        if(usd){
          const threshold=Number(shipping.dataset.threshold)||5000;
          const subtotalCents=Math.max(0,Number(cart.total_price)||0);
          const remaining=Math.max(0,threshold-subtotalCents);
          const progress=Math.min(100,Math.max(0,subtotalCents/threshold*100));
          const shippingMessage=shipping.querySelector('[data-ov-ship-message]');
          const shippingStatus=shipping.querySelector('[data-ov-ship-status]');
          const shippingTrack=shipping.querySelector('[data-ov-shipping-track]');
          const shippingFill=shipping.querySelector('[data-ov-shipping-fill]');
          if(shippingMessage)shippingMessage.textContent=remaining>0?
            drawer.dataset.shippingRemaining.replace('__AMOUNT__',cartMoney(remaining,'USD')):
            drawer.dataset.shippingUnlocked;
          if(shippingStatus)shippingStatus.textContent=remaining>0?drawer.dataset.shippingGoal:drawer.dataset.unlocked;
          if(shippingFill)shippingFill.style.width=progress.toFixed(2)+'%';
          if(shippingTrack)shippingTrack.setAttribute('aria-valuenow',String(Math.round(progress)));
        }
      }
      root.querySelectorAll('[data-ov-cart-count]').forEach(label=>{label.textContent=String(cart.item_count||0);});
      footer.hidden=items.length===0;
      if(!items.length){
        itemsContainer.appendChild(drawerEl('p','ov-cart-drawer__empty',drawer.dataset.emptyText));
        return;
      }
      items.forEach(item=>{
        const line=drawerEl('article','ov-cart-drawer__item');
        const image=item.image?drawerEl('img','ov-cart-drawer__item-img'):drawerEl('div','ov-cart-drawer__item-img');
        if(item.image){
          image.src=item.image;
          image.alt=item.product_title||'';
          image.loading='lazy';
        }
        line.appendChild(image);
        const body=drawerEl('div','ov-cart-drawer__item-body');
        body.appendChild(drawerEl('strong','ov-cart-drawer__item-name',item.product_title));
        if(item.variant_title&&item.variant_title!=='Default Title'){
          body.appendChild(drawerEl('span','ov-cart-drawer__item-variant',item.variant_title));
        }
        body.appendChild(drawerEl('strong','ov-cart-drawer__item-price',cartMoney(item.final_line_price,cart.currency)));
        const controls=drawerEl('div','ov-cart-drawer__controls');
        const qty=drawerEl('div','ov-cart-drawer__qty');
        const minus=drawerEl('button',null,'−');
        minus.type='button';
        minus.dataset.ovQty='-1';
        minus.dataset.lineKey=item.key;
        minus.disabled=item.quantity<=1;
        minus.setAttribute('aria-label',(drawer.dataset.decreaseText||'Decrease quantity')+' '+item.product_title);
        const number=drawerEl('span',null,item.quantity);
        const plus=drawerEl('button',null,'+');
        plus.type='button';
        plus.dataset.ovQty='1';
        plus.dataset.lineKey=item.key;
        plus.setAttribute('aria-label',(drawer.dataset.increaseText||'Increase quantity')+' '+item.product_title);
        qty.append(minus,number,plus);
        const remove=drawerEl('button','ov-cart-drawer__remove',drawer.dataset.removeText||'Remove');
        remove.type='button';
        remove.dataset.ovRemove=item.key;
        controls.append(qty,remove);
        body.appendChild(controls);
        line.appendChild(body);
        itemsContainer.appendChild(line);
      });
    }
    const refreshDrawer=async()=>{
      const options={headers:{Accept:'application/json'},credentials:'same-origin'};
      let response=await fetchCartRoute('cart.js',options);
      if(!response.ok)throw Error('Unable to load cart (HTTP '+response.status+').');
      let cart;
      try{cart=await response.json();}catch(error){
        // GET is safe to retry if an unsupported language endpoint returned HTML.
        if(cartBase==='/')throw error;
        response=await fetch('/cart.js',options);
        if(!response.ok)throw Error('Unable to load cart (HTTP '+response.status+').');
        cart=await response.json();
      }
      if(!cart||!Array.isArray(cart.items))throw Error('Invalid cart response.');
      renderDrawer(cart);
    };
    function drawerError(message){
      if(!drawer)return;
      const contents=drawer.querySelector('[data-ov-drawer-items]');
      if(!contents)return;
      contents.replaceChildren();
      contents.appendChild(drawerEl('p','ov-cart-drawer__message',message));
      const fallback=drawerEl('a','ov-cart-drawer__fallback',drawer.dataset.viewCart||'View cart');
      fallback.href=cartBase+'cart';
      contents.appendChild(fallback);
    }
    const closeDrawer=()=>{
      if(!drawer||drawer.hidden)return;
      drawer.classList.remove('is-open');
      document.body.classList.remove('ov-cart-drawer-open');
      window.clearTimeout(closingTimer);
      closingTimer=window.setTimeout(()=>{if(!drawer.classList.contains('is-open'))drawer.hidden=true;},260);
      if(previousFocus&&previousFocus.isConnected)previousFocus.focus({preventScroll:true});
      updateSticky();
    };
    const openDrawer=async(trigger)=>{
      if(!drawer){window.location.assign(cartBase+'cart');return;}
      window.clearTimeout(closingTimer);
      previousFocus=trigger||document.activeElement;
      drawer.hidden=false;
      drawer.classList.add('is-open');
      document.body.classList.add('ov-cart-drawer-open');
      updateSticky();
      const close=drawer.querySelector('.ov-cart-drawer__close');
      if(close)close.focus({preventScroll:true});
      const contents=drawer.querySelector('[data-ov-drawer-items]');
      if(contents)contents.replaceChildren(drawerEl('p','ov-cart-drawer__message','…'));
      try{await refreshDrawer();}
      catch(error){console.error(error);drawerError(drawer.dataset.loadError||'Unable to load cart.');}
    };
    async function changeDrawerQuantity(key,quantity){
      if(!drawer||!key||drawer.classList.contains('is-busy'))return;
      drawer.classList.add('is-busy');
      drawer.querySelectorAll('[data-ov-qty],[data-ov-remove]').forEach(button=>button.disabled=true);
      try{
        const response=await fetchCartRoute('cart/change.js',{
          method:'POST',
          credentials:'same-origin',
          headers:{'Content-Type':'application/json',Accept:'application/json'},
          body:JSON.stringify({id:key,quantity:Math.max(0,quantity)})
        });
        if(!response.ok)throw Error('Cart update failed');
        renderDrawer(await response.json());
      }catch(error){
        console.error(error);
        drawerError(drawer.dataset.updateError||'Unable to update cart. Please view cart.');
      }finally{
        drawer.classList.remove('is-busy');
        drawer.querySelectorAll('[data-ov-qty],[data-ov-remove]').forEach(button=>{
          const isDecrement=button.dataset.ovQty==='-1';
          const item=cartData?.items?.find(line=>line.key===button.dataset.lineKey);
          button.disabled=Boolean(isDecrement&&item&&item.quantity<=1);
        });
      }
    }
    drawer?.addEventListener('click',event=>{
      if(event.target.closest('[data-ov-drawer-close]')){closeDrawer();return;}
      const qtyButton=event.target.closest('[data-ov-qty]');
      const removeButton=event.target.closest('[data-ov-remove]');
      if(!qtyButton&&!removeButton)return;
      const key=qtyButton?.dataset.lineKey||removeButton?.dataset.ovRemove;
      const item=cartData?.items?.find(line=>line.key===key);
      if(!item)return;
      const desired=removeButton?0:item.quantity+Number(qtyButton.dataset.ovQty||0);
      changeDrawerQuantity(key,desired);
    });
    drawer?.addEventListener('keydown',event=>{
      if(event.key==='Escape'){event.preventDefault();closeDrawer();return;}
      if(event.key!=='Tab')return;
      const focusables=[...drawer.querySelectorAll('a[href],button:not([disabled]),[tabindex]:not([tabindex="-1"])')].filter(el=>el.getClientRects().length>0);
      if(!focusables.length)return;
      if(event.shiftKey&&document.activeElement===focusables[0]){event.preventDefault();focusables[focusables.length-1].focus();}
      else if(!event.shiftKey&&document.activeElement===focusables[focusables.length-1]){event.preventDefault();focusables[0].focus();}
    });
    root.querySelectorAll('[data-ov-open-cart]').forEach(link=>link.addEventListener('click',event=>{
      if(!drawer)return;
      event.preventDefault();
      openDrawer(link);
    }));
    root.addEventListener('ovela:cart:added',()=>openDrawer(purchaseButton));
    stickyButton?.addEventListener('click',()=>{
      if(purchaseForm&&purchaseButton){
        if(typeof purchaseForm.requestSubmit==='function')purchaseForm.requestSubmit(purchaseButton);
        else purchaseButton.click();
      }
    });
    window.addEventListener('scroll',updateSticky,{passive:true});
    window.addEventListener('resize',updateSticky);
    updateSticky();
    const contactPanel=root.querySelector('details#ov-contact');
    if(location.hash==='#ov-contact'&&contactPanel)contactPanel.open=true;
    root.querySelectorAll('.ov-contact-form .errors,.ov-contact-form [role="status"]').forEach(()=>{if(contactPanel)contactPanel.open=true;});
  }
  document.querySelectorAll('[data-ovela]').forEach(init);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-ovela]').forEach(init));
})();



/* Ovela AJAX cart */
(()=>{
  const CART_ROOT = '.ovela-cart';
  const BUNDLE_TOTALS = [1, 3, 5];
  let busy = false;

  function setBusy(root, state) {
    busy = state;
    root.classList.toggle('is-cart-updating', state);
    root.querySelectorAll('.ov-cart-qty-btn, .ov-cart-remove, .ov-cart-checkout').forEach(el => {
      if ('disabled' in el) el.disabled = state;
      el.setAttribute('aria-busy', state ? 'true' : 'false');
    });
  }

  async function refreshCart(root) {
    const response = await fetch(window.location.pathname + '?sections=main', {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    });
    if (!response.ok) throw new Error('Unable to refresh cart');

    const sections = await response.json();
    const doc = new DOMParser().parseFromString(sections.main || '', 'text/html');
    const nextMain = doc.querySelector('.ov-cart-main');
    const currentMain = root.querySelector('.ov-cart-main');

    if (!nextMain || !currentMain) {
      window.location.reload();
      return;
    }

    currentMain.replaceWith(nextMain);
    bindCart(root);
  }

  async function setBundleTotal(root, paidLine, productId, targetTotal) {
    if (busy) return;
    setBusy(root, true);

    try {
      const allCartLines = [...root.querySelectorAll('.ov-cart-line')];
      const updates = allCartLines.map(line => {
        const lineNumber = Number(line.dataset.cartLine);
        const lineProductId = line.dataset.productId;
        const currentQuantity = Number(line.dataset.lineQuantity || 0);

        if (lineProductId !== productId) return currentQuantity;
        return lineNumber === paidLine ? targetTotal : 0;
      });

      const localeCartRoot=window.Shopify?.routes?.root||'/';
      let response = await fetch(localeCartRoot+'cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ updates })
      });
      if(!response.ok&&(response.status===404||response.status===405)&&localeCartRoot!=='/'){
        response=await fetch('/cart/update.js',{
          method:'POST',credentials:'same-origin',
          headers:{'Content-Type':'application/json','Accept':'application/json','X-Requested-With':'XMLHttpRequest'},
          body:JSON.stringify({updates})
        });
      }

      if (!response.ok) throw new Error('Unable to update bundle (HTTP '+response.status+')');
      await refreshCart(root);
    } catch (error) {
      console.error(error);
      window.location.reload();
    } finally {
      setBusy(root, false);
    }
  }

  function getCurrentTotal(root, productId) {
    return [...root.querySelectorAll('.ov-cart-line[data-product-id="' + productId + '"]')]
      .reduce((sum, line) => sum + Number(line.dataset.lineQuantity || 0), 0);
  }

  function bindCart(root) {
    if (!root) return;

    root.querySelectorAll('.ov-cart-qty-control').forEach(control => {
      const input = control.querySelector('.ov-cart-qty');
      const article = control.closest('.ov-cart-line');
      const paidLine = Number(control.dataset.cartLine);
      const productId = article?.dataset.productId;
      if (!input || !paidLine || !productId) return;

      const currentTotal = getCurrentTotal(root, productId);
      input.value = String(currentTotal);

      const decrease = control.querySelector('[data-cart-qty-action="decrease"]');
      const increase = control.querySelector('[data-cart-qty-action="increase"]');

      if (decrease) decrease.disabled = currentTotal <= 1;
      if (increase) increase.disabled = currentTotal >= 5;

      control.querySelectorAll('[data-cart-qty-action]').forEach(button => {
        if (button.dataset.ajaxBound === 'true') return;
        button.dataset.ajaxBound = 'true';

        button.addEventListener('click', () => {
          const current = getCurrentTotal(root, productId);
          let target = current;

          if (button.dataset.cartQtyAction === 'increase') {
            target = BUNDLE_TOTALS.find(qty => qty > current) || 5;
          } else {
            const lower = BUNDLE_TOTALS.filter(qty => qty < current);
            target = lower.length ? lower[lower.length - 1] : 1;
          }

          if (target !== current) {
            input.value = String(target);
            setBundleTotal(root, paidLine, productId, target);
          }
        });
      });
    });

    root.querySelectorAll('.ov-cart-remove').forEach(link => {
      if (link.dataset.ajaxBound === 'true') return;
      link.dataset.ajaxBound = 'true';

      link.addEventListener('click', event => {
        event.preventDefault();
        const article = link.closest('.ov-cart-line');
        const paidLine = Number(article?.dataset.cartLine);
        const productId = article?.dataset.productId;
        if (paidLine && productId) setBundleTotal(root, paidLine, productId, 0);
      });
    });
  }

  function initCart() {
    bindCart(document.querySelector(CART_ROOT));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCart, { once: true });
  } else {
    initCart();
  }

  document.addEventListener('shopify:section:load', initCart);
})();
